'use client';

import { useState, useEffect } from 'react';
import LoginModal from '@fe-news/components/molecules/LoginModal';
import useAuth, { getProfile } from '@fe-news/hooks/auth';
import { redirect } from 'next/navigation';
import LinkFactory from '@fe-common-utils/libs/link';

const MyComment = () => {
  const [status] = useAuth();
  const isLoggedIn = status === 'login';
  const [isCloseLoginModal, setIsCloseLoginModal] = useState(isLoggedIn);

  const onClickLoginModalClose = () => {
    setIsCloseLoginModal(true);
  };

  useEffect(() => {
    if (isLoggedIn) {
      const profile = getProfile();
      const haoLoginId = profile?.hao_login_id;
      setIsCloseLoginModal(true);
      redirect(`${LinkFactory.anueHaoLink}/ch/${haoLoginId}`);
    }
  }, [isLoggedIn]);

  return (
    <div>
      <LoginModal isModalClosed={isCloseLoginModal} onClickModalClose={onClickLoginModalClose} />
    </div>
  );
};

export default MyComment;
